import type { ConstellationSplashTiming } from '../components/Common/ConstellationSplash'

export const BOOT_CONSTELLATION_SPLASH_TIMING: ConstellationSplashTiming = {
  enterMs: 80,
  formMs: 1000,
  holdMs: 200,
  fadeBgMs: 140,
  fadeDriftMs: 80,
}
